import { makeStyles } from "@material-ui/core/styles";

export const onboardingStyles = makeStyles(() => ({
  container: {
    backgroundColor: "#F1F5F9",
  },
}));
